import Floodlight from "@/pixels/providers/floodlight";

describe("Floodlight", () => {
  beforeEach(() => {
    // Reset any modifications made to the document
    document.body.innerHTML = "";
  });

  it("should enable Floodlight", () => {
    Floodlight.enable();
    // Add your assertion here
  });

  it("should return true when waiting", () => {
    const result = Floodlight.wait();
    expect(result).toBe(true);
  });

  it("should initialize Floodlight", () => {
    Floodlight.init();
    // Add your assertion here
  });

  it("should track landing", () => {
    Floodlight.landing();
    // Add your assertion here
  });

  it("should track paso1", () => {
    Floodlight.paso1();
    // Add your assertion here
  });

  it("should track paso2", () => {
    Floodlight.paso2();
    // Add your assertion here
  });

  it("should track paso3", () => {
    Floodlight.paso3();
    // Add your assertion here
  });

  it("should track paso4", () => {
    Floodlight.paso4();
    // Add your assertion here
  });

  it("should send gracias event", () => {
    Floodlight.gracias();
    // Add your assertion here
  });

  it("should track mensaje", () => {
    Floodlight.mensaje();
    // Add your assertion here
  });
});
